<div class="sticky top-0 z-50 hidden lg:flex items-center justify-between py-2 text-white">

  <div class="flex items-center gap-2 xl:gap-3">
    <a [routerLink]="['/product']"
       class="flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer group"
       >
      <div
        class="flex justify-center items-center bg-secondary/20 border border-secondary/40 w-9 h-9 xl:w-10 xl:h-10 rounded-full group-hover:scale-110 transition-transform">
        <mat-icon class="material-symbols-outlined icon-secondary">delivery_dining</mat-icon>
      </div>
      <span class="font-bold uppercase text-xl tracking-wide title text-[#FFFFFF]/90 hover:text-secondary">Commander</span>
    </a>

    <div class="border-l border-primary/30 h-6"></div>

    <a [routerLink]="['/restaurant']" class="flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer group">
      <div class="flex justify-center items-center bg-secondary/20 border border-secondary/40 w-9 h-9 xl:w-10 xl:h-10 rounded-full group-hover:scale-110 transition-transform">
        <mat-icon class="material-symbols-outlined icon-secondary">location_on</mat-icon>
      </div>
      <span class="font-bold uppercase text-xl tracking-wide title text-[#FFFFFF]/90 hover:text-secondary">Notre Restaurant</span>
    </a>

    @if (!hasAnyPromoCodeApplied()) {
      <button class="flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer group"
        (click)="openPromoCodeDialog()"
        >
        <div
          class="flex justify-center items-center bg-secondary/20 border border-secondary/40  w-9 h-9 xl:w-10 xl:h-10 rounded-full group-hover:scale-110 transition-transform">
          <mat-icon class="material-symbols-outlined icon-secondary">confirmation_number</mat-icon>
        </div>
        <span class="font-bold uppercase text-xl tracking-wide title text-[#FFFFFF]/90 hover:text-secondary">Code promo</span>
      </button>
    }
  </div>

  <a [routerLink]="['']" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
  w-20 h-20 flex items-center justify-center overflow-hidden   ">
    <img
      [ngSrc]="logo() || 'assets/images/placeholders/placeholder.webp'"
      [alt]="'Logo pour ' + restoName() || 'le restaurant'"
      fill
      priority
      sizes="10vw"
      class="object-contain object-center p-1 cursor-pointer transition-transform hover:scale-110" />
  </a>

    <div class="flex items-center gap-2 xl:gap-3">
      <a [routerLink]="['/allergene']" class="flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer group">
        <div
          class="flex justify-center items-center bg-secondary/20 border border-secondary/40  w-9 h-9 xl:w-10 xl:h-10 rounded-full group-hover:scale-110 transition-transform">
          <mat-icon class="material-symbols-outlined icon-secondary">restaurant</mat-icon>
        </div>
        <span class="font-bold uppercase text-xl tracking-wide title text-[#FFFFFF]/90 hover:text-secondary">Allergènes</span>
      </a>

      <button class="flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer group"
        (click)="scrollToContact()">
        <div
          class="flex justify-center items-center bg-secondary/20 border border-secondary/40  w-9 h-9 xl:w-10 xl:h-10 rounded-full group-hover:scale-110 transition-transform">
          <mat-icon class="material-symbols-outlined icon-secondary">contact_support</mat-icon>
        </div>
        <span class="font-bold uppercase text-xl tracking-wide title text-[#FFFFFF]/90 hover:text-secondary">Contact</span>
      </button>

      <!--    <div class="border-l border-primary/30 h-7 mx-2"></div>-->

      <div
        class="relative flex justify-center items-center bg-secondary/20 border border-secondary/40  w-10 h-10 rounded-full cursor-pointer hover:scale-110 transition-transform"
        (click)="toggleCart()">
        @if (cartService.itemCount() > 0) {
          <span
            class="absolute -top-2 -right-2 bg-secondary text-[#FFFFFF] w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold border-2 border-[#FFFFFFFF] shadow-lg">
            {{ cartService.itemCount() }}
          </span>
        }
        <mat-icon class="material-symbols-outlined icon-secondary">shopping_cart</mat-icon>
      </div>

      <div
        class="flex justify-center items-center bg-secondary/20 border border-secondary/40  w-10 h-10 rounded-full cursor-pointer hover:scale-110 transition-transform"
        (click)="openDialogLogin()">
        <mat-icon class="material-symbols-outlined icon-secondary">person</mat-icon>
      </div>
    </div>
  </div>

  <div
    class="lg:hidden fixed inset-x-0 top-0 z-50  bg-[#1A1A1A]/40 backdrop-blur-md border-b border-primary/20 p-2 flex items-center justify-between">
    <a [routerLink]="['']" class="relative w-11 h-11 flex items-center justify-center overflow-hidden">
      <img
        [ngSrc]="logo() || 'assets/images/placeholders/placeholder.webp'"
        [alt]="'Logo pour ' + (restoName() || 'le restaurant')"
        fill
        priority
        class="object-contain object-center p-1 cursor-pointer transition-transform hover:scale-110" />
    </a>

      <div class="flex items-center gap-2">
        <div class="flex justify-center items-center bg-secondary/20 border border-secondary/40  w-10 h-10 rounded-full"
          (click)="openDialogLogin()">
          <mat-icon class="material-symbols-outlined icon-secondary">person</mat-icon>
        </div>
        @if (!hasAnyPromoCodeApplied()) {
          <div class="flex justify-center items-center bg-secondary/20 border border-secondary/40  w-10 h-10 rounded-full"
            (click)="openPromoCodeDialog()"
            >
            <mat-icon class="material-symbols-outlined icon-secondary">confirmation_number</mat-icon>
          </div>
        }
        <div
          class="flex justify-center items-center bg-secondary/20 border border-secondary/40 w-10 h-10 rounded-full shadow-lg"
          (click)="toggleMenu()">
          <mat-icon class="material-symbols-outlined icon-secondary">menu</mat-icon>
        </div>
      </div>
    </div>

    <!-- Mobile Navbar -->
    @if (isCartSlideOpen) {
      <div
        class="fixed inset-0  bg-[#1A1A1A]/40 transition-opacity duration-300"
        style="z-index: 9999;"
        (click)="toggleCart()">
      </div>
    }
    <!-- Panier (au-dessus de l'overlay) -->
    @if (isCartSlideOpen) {
      <div
     class="fixed top-0 right-0 h-full w-[447px] card z-[10000]
         transform transition-transform duration-300 ease-in-out
         flex flex-col"
        style="z-index: 10000 !important;"
        [class.translate-x-0]="isCartSlideOpen"
        [class.translate-x-full]="!isCartSlideOpen"
        (click)="$event.stopPropagation()"
        >
        <!-- HEADER -->
        <div class="flex-shrink-0 flex justify-between items-center p-4 border-b text-gray-600">
          <h2 class="text-lg font-bold title">🛒 Mon Panier</h2>
          <button (click)="toggleCart()" class="cursor-pointer">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <!-- CONTENT (SCROLLABLE) -->
        <div class="flex-1 overflow-y-auto overscroll-contain">
          <!-- PANIER VIDE -->
          @if (cartService.isEmpty()) {
            <div class="p-4 space-y-4">
              <div class="relative w-full h-64 flex justify-center items-center">
                <img
                  [ngSrc]="'assets/images/shopping-cart.webp'"
                  alt="Panier vide"
                  fill
                  priority
                  sizes="100vw"
                  class="object-contain" />
              </div>
                <p class="text-center text-site">
                  Votre panier est vide pour le moment
                </p>
              <button
                type="button"
                (click)="openDialog(); toggleCart()"
                class="w-full bg-accent text-accent-content hover:bg-accent-dim py-3 rounded-field duration-200 font-bold cursor-pointer z-10">
                Commander
              </button>
              </div>
            }
            <!-- ITEMS PANIER -->
            @if (!cartService.isEmpty()) {
              <div class="space-y-4 p-4">
                @for (item of cartService.items(); track item) {
                  <div class="px-4 py-2 bg-base-100 rounded-box">
                    <!-- TYPE -->
                    <span
                      class="inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold"
                      [class.bg-blue-100]="item.type === CartItemType.PRODUCT"
                      [class.text-blue-800]="item.type === CartItemType.PRODUCT"
                      [class.bg-green-100]="item.type === CartItemType.BUNDLE"
                      [class.text-green-800]="item.type === CartItemType.BUNDLE"
                      [class.bg-purple-100]="item.type === CartItemType.PROMOTION"
                      [class.text-purple-800]="item.type === CartItemType.PROMOTION">
                      @if (item.type === CartItemType.PRODUCT) {
                        <span>🍔 Produit</span>
                      }
                      @if (item.type === CartItemType.BUNDLE) {
                        <span>🍱 Menu</span>
                      }
                      @if (item.type === CartItemType.PROMOTION) {
                        <span>🎁 Promotion</span>
                      }
                    </span>
                    <!-- HEADER ITEM -->
                    <div class="flex justify-between items-start mt-2">
                      <div class="flex-1">
                        <h3 class="font-bold text-site text-[16px] flex items-center gap-1 flex-wrap">
                          {{ getItemTitle(item) }}
                @if (isRedeemItem(item) && getItemPointsCost(item) > 0) {
                <span class="inline-flex items-center gap-1 text-[11px] font-bold bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full border border-purple-300 shadow-sm">
          <mat-icon class="text-[13px] w-3.5 h-3.5 leading-none flex items-center justify-center">stars</mat-icon>
          <span>{{ getItemPointsCost(item) * item.quantity }} pts</span>
        </span>
                }
                @if (!isRedeemItem(item) && item.type === CartItemType.PRODUCT && hasProductDiscount(item)) {
                <span class="text-[13px] line-through text-gray-400 font-bold">
                              {{ truncate2(getProductOriginalPrice(item) * item.quantity) | number:'1.2-2' }}€
                            </span>
                            <span class="text-[13px] font-bold text-green-700">
                              {{ getDiscountedTotalPrice(item) | number:'1.2-2' }}€
                            </span>
                            @if (getProductDiscountBadge(item)) {
                              <span class="text-[11px] font-bold bg-green-100 text-green-800 px-1.5 py-0.5 rounded-full"
                                >
                                {{ getProductDiscountBadge(item) }}
                              </span>
                            }
                          }
                        </h3>
                      </div>
                      <div class="flex items-center gap-2">
                        @if (item.type === CartItemType.PRODUCT && !isPromoCodeProduct(item) && canEditProduct(item)) {
                          <button
                            (click)="editCartItem(item)"
              class="h-6 w-6 flex items-center justify-center rounded-full hover:bg-bg-primary transition-colors text-[#71717a]
                  hover-text-primary"
                            >
                            <!--              <mat-icon class="text-[16px]" style="font-size:16px; width:16px; height:16px; line-height:16px;">edit-->
                          <!--              </mat-icon>-->
                          <!--              <span>Modifier</span>-->
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-pencil h-3 w-3 hover-text-primary" aria-hidden="true">
                            <path
                            d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                            <path d="m15 5 4 4"></path>
                          </svg>
                        </button>
                      }
                      @if (item.type === CartItemType.BUNDLE) {
                        <button
                          (click)="editBundleCartItem(item)"
              class="h-6 w-6 flex items-center justify-center rounded-full hover:bg-bg-primary transition-colors text-[#71717a]
                  hover-text-primary"
                          >
                          <!--              <mat-icon class="text-[16px]" style="font-size:16px; width:16px; height:16px; line-height:16px;">edit-->
                        <!--              </mat-icon>-->
                        <!--              <span>Modifier</span>-->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-pencil h-3 w-3 hover-text-primary" aria-hidden="true">
                          <path
                          d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                          <path d="m15 5 4 4"></path>
                        </svg>
                      </button>
                    }
                    @if (item.type === CartItemType.PROMOTION && !isOrderOffer(item) && !isPromoCodeProductOffer(item)) {
                      <button
                        (click)="editPromoCartItem(item)"
              class="h-6 w-6 flex items-center justify-center rounded-full hover:bg-bg-primary transition-colors text-[#71717a]
                  hover-text-primary"
                        >
                        <!--              <mat-icon class="text-[16px]" style="font-size:16px; width:16px; height:16px; line-height:16px;">edit-->
                      <!--              </mat-icon>-->
                      <!--              <span>Modifier</span>-->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-pencil h-3 w-3 hover-text-primary" aria-hidden="true">
                        <path
                        d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>
                        <path d="m15 5 4 4"></path>
                      </svg>
                    </button>
                  }
                  <button
                    (click)="removeItem(item.id)"
              class="h-6 w-6 flex items-center justify-center rounded-full hover:bg-primary hover:text-dark
              text-[#71717a] transition-colors"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-x h-3.5 w-3.5 text-text-muted " aria-hidden="true">
                      <path d="M18 6 6 18"></path>
                      <path d="m6 6 12 12"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <!-- DETAILS -->
              <div class="space-y-2 mb-3 text-sm mt-2">
                <!--          <ng-container *ngIf="item.type === CartItemType.PRODUCT">-->
                <!--            <div class="text-dark text-sm leading-relaxed"-->
                <!--                 *ngIf="getProductCustomizationText(item)">-->
                <!--              <div class="space-y-1">-->
                <!--                <div *ngFor="let line of getProductCustomizationText(item).split('\n')">-->
                <!--              <span-->
                <!--                [class.text-red-600]="line.startsWith('Sans')"-->
                <!--                [class.font-bold]="line.startsWith('Sans')"-->
                <!--                class="block">-->
                <!--                {{ line }}-->
              <!--              </span>-->
            <!--                </div>-->
          <!--              </div>-->
        <!--            </div>-->
      <!--          </ng-container>-->
      @if (item.type === CartItemType.PRODUCT) {
        @if (getProductCustomizationText(item) || getProductSupplementsStructured(item).length > 0) {
          <div class="text-dark text-sm leading-relaxed"
            >
            <div class="space-y-1">
              <!-- Lignes normales (Sans, Sauces, Viandes...) -->
              @for (line of getProductCustomizationText(item).split('\n'); track trackCompositionLine(line, $index)) {
                <div>
                  <span
                    [class.text-red-600]="line.startsWith('Sans')"
                    [class.font-bold]="line.startsWith('Sans')"
                    class="block">
                    {{ line }}
                  </span>
                </div>
              }
              <!-- Suppléments avec catégorie colorée -->
              @if (getProductSupplementsStructured(item).length > 0) {
                <div
                  class="flex flex-wrap items-center gap-1 mt-0.5">
                  <span class="font-semibold text-gray-400">
                    Suppléments {{ getProductSupplemenstTotalPrice(item) }} :
                  </span>
                  @for (supp of getProductSupplementsStructured(item); track trackCompositionLine(supp.name, $index); let last = $last) {
                    <span
                      class="inline-flex items-center gap-0.5">
                      <!-- Catégorie en orange -->
                      <span class="text-primary font-semibold">{{ supp.category }}</span>
                      <span class="text-gray-400">-</span>
                      <!-- Nom du supplément + prix -->
                      <span class="text-gray-600">{{ supp.name }} {{ supp.priceText }}</span>
                      @if (!last) {
                        <span class="text-gray-400">,</span>
                      }
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
      @if (item.type === CartItemType.BUNDLE) {
        <div class="mt-2 text-dark text-sm leading-relaxed ml-2">
          <span class="font-semibold text-green-600">Composition :</span>
          <div class="mt-1">
            @for (line of getBundleCompositionWithCustomizations(item).split('\n'); track trackCompositionLine(line, $index)) {
              <div>
                <!-- 🟢 PRODUCT -->
                @if (line.startsWith('[PRODUCT]')) {
                  <span
                    class="block font-bold">
                    {{ line.replace('[PRODUCT]', '') }}
                  </span>
                }
                <!-- 🔴 SANS -->
                @if (line.startsWith('Sans')) {
                  <span
                    class="block text-red-600 ml-4">
                    {{ line }}
                  </span>
                }
                <!-- 🟡 SUPPLÉMENTS (CUSTOM RENDER) -->
                @if (line.startsWith('Suppléments')) {
                  <div class="ml-4">
                    <!-- titre + prix -->
                    <span>
                      {{ line.split(':')[0] }} :
                    </span>
                    <!-- contenu -->
                    @for (part of line.split(':')[1].split('|||'); track trackCompositionLine(part, $index); let last = $last) {
                      <span class="ml-1">
                        @if (part.includes('[CAT]')) {
                          <span class="text-orange-500 font-semibold">
                            {{ part.split('-')[0].replace('[CAT]', '').trim() }}
                          </span>
                          - {{ part.split('-').slice(1).join('-') }}
                        } @else {
                          {{ part }}
                        }
                      </span>@if (!last) {
                      <span>, </span>
                    }
                  }
                </div>
              }
              <!-- 🔵 AUTRES -->
              @if (!line.startsWith('[PRODUCT]')
                && !line.startsWith('Sans')
                && !line.startsWith('Suppléments')) {
                <span
                  class="block ml-4">
                  {{ line }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (item.type === CartItemType.PROMOTION) {
      <div class="mt-3 text-sm">
        <!-- ══ ORDER-OFFER : ingrédients / accompagnements / suppléments ══ -->
        @if (isOrderOffer(item)) {
          <div class="bg-green-50 border border-green-200 rounded-lg p-2">
            <!-- Header avec badge réduction -->
            <div class="flex items-center justify-between mb-2">
              <p class="text-xs font-bold text-green-700">🎁 Produits Offerts</p>
              @if (isSetPriceReduction(item)) {
                <span class="text-xs font-bold text-green-700">
                  ({{ getSetPriceValue(item) | number:'1.2-2' }}€)
                </span>
              }
              @if (!isSetPriceReduction(item)) {
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-800 border border-green-300">
                  {{ getOrderOfferReductionBadge(item) }}
                </span>
              }
            </div>
            @for (offered of getOfferedItems(item); track offered) {
              <div
                class="mb-3 pb-2 border-b border-green-100 last:border-0 last:mb-0 last:pb-0">
                <!-- Produit + colonne prix -->
                <div class="flex items-center justify-between mb-1">
                  <div class="flex items-center gap-2 flex-1">
                    <div class="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 bg-white">
                      <img
                        [ngSrc]="offered.product?.image || 'assets/images/placeholders/placeholder.webp'"
                        [alt]="offered.product?.name || 'Image à venir'"
                        width="32"
                        height="32"
                        loading="lazy"
                        class="w-full h-full object-cover" />
                    </div>
                    <span class="font-semibold text-[#1A1A1A] text-xs">
    {{ offered.product?.name }}
  </span>
                  </div>
                    <!-- Colonne prix (à droite) -->
                    <div class="flex flex-col items-end gap-0.5 flex-shrink-0 ml-2">
                      @if (isFixedAmountOrderOffer(item) && !isSetPriceReduction(item)) {
                        <span class="text-xs text-gray-400 font-semibold">
                          {{ (offered.unitBasePrice || 0) | number:'1.2-2' }}€
                        </span>
                      }
                      <!-- PERCENTAGE → prix barré + prix réduit -->
                      @if (!isFixedAmountOrderOffer(item) && !isSetPriceReduction(item)) {
                        @if ((offered.unitBasePrice || 0) > (offered.unitPrice || 0)) {
                          <span class="text-xs line-through text-gray-400"
                            >
                            {{ (offered.unitBasePrice || 0) | number:'1.2-2' }}€
                          </span>
                        }
                        @if ((offered.unitPrice || 0) === 0) {
                          <span class="text-xs font-bold text-green-600"
                            >
                            Gratuit 🎁
                          </span>
                        }
                        @if ((offered.unitPrice || 0) > 0) {
                          <span class="text-xs font-bold text-green-700"
                            >
                            {{ ((offered.unitPrice || 0) - (offered.unitSupplementsPrice || 0)) | number:'1.2-2' }}€
                          </span>
                        }
                      }
                    </div>
                  </div>
                  <!-- Sans (ingrédients exclus) -->
                  @if (offered.excludedIngredients?.length > 0) {
                    <div
                      class="pl-10 text-xs text-red-500 mb-0.5">
                      <span class="font-semibold">Sans : </span>
                      @for (ing of offered.excludedIngredients; track trackCompositionLine(ing, $index) ; let last = $last) {
                        <span>
                          {{ ing.name }}@if (!last) {
                          <span>, </span>
                        }
                      </span>
                    }
                  </div>
                }
                <!-- Accompagnements -->
                @if (offered.selectedAdditions?.length > 0) {
                  <div
                    class="pl-10 text-xs text-gray-600 mb-0.5">
                    <span class="font-semibold text-orange-600">Accompagnements : </span>
                    @for (acc of offered.selectedAdditions; track trackCompositionLine(acc, $index); let last = $last) {
                      <span>
                        {{ acc.name }}
                        @if (acc.quantity > 1) {
                          <span class="text-gray-400"> x{{ acc.quantity }}</span>
                        }
                        @if (!last) {
                          <span>, </span>
                        }
                      </span>
                    }
                  </div>
                }
                <!-- Suppléments -->
                @if (offered.selectedSupplements?.length > 0) {
                  <div
                    class="pl-10 text-xs text-gray-600">
                    <span class="font-semibold text-orange-600">
                      Suppléments
                      <span class="text-purple-500">
                        (+{{ getTotalSupplementsPrice(offered) | number:'1.2-2' }}€)
                      </span> :
                    </span>
                    @for (sup of offered.selectedSupplements; track trackCompositionLine(sup, $index); let last = $last) {
                      <span>
                        {{ sup.name }}
                        <!--                        <span class="text-purple-500 font-semibold" *ngIf="sup.price">-->
                        <!--            (+{{ sup.price | number:'1.2-2' }}€)-->
                      <!--          </span>-->
                      @if (getSupPrice(sup, offered) > 0) {
                        <span class="text-purple-500 font-semibold"
                          >
                          (+{{ getSupPrice(sup, offered) | number:'1.2-2' }}€)
                        </span>
                      }
                      @if (!last) {
                        <span>, </span>
                      }
                    </span>
                  }
                </div>
              }
            </div>
          }
          <!-- ✅ Récapitulatif total pour FIXED_AMOUNT -->
          @if (isFixedAmountOrderOffer(item)) {
            <div
              class="mt-2 pt-2 space-y-1">
              <div class="flex justify-between items-center text-xs text-gray-500">
                <span>Total produits</span>
                <span class="font-semibold">{{ getOrderOfferTotalBase(item) | number:'1.2-2' }}€</span>
              </div>
              <div class="flex justify-between items-center text-xs text-green-700">
                <span>Remise</span>
                <span class="font-bold">-{{ getOrderOfferFixedDiscount(item) | number:'1.2-2' }}€</span>
              </div>
              <!--                    <div class="flex justify-between items-center text-xs font-bold border-t border-green-200 pt-1 mt-1">-->
              <!--                      <span class="text-gray-700">Total après remise</span>-->
              <!--                      <span class="text-orange-600">{{ getOrderOfferTotalAfterDiscount(item) | number:'1.2-2' }}€</span>-->
            <!--                    </div>-->
          </div>
        }
      </div>
    }
    <!-- ══ AUTRES PROMOS (product-offer / bundle-offer) : code existant ══ -->
    @if (!isOrderOffer(item)) {
      <div class="space-y-3">
        @if (item.promotion.payload?.cheapestOffered) {
          <div class="bg-[#fcf8e3] border-l-4 border-l-[#8a6d3b] flex items-center mb-0 gap-3 p-3"
            >
            <mat-icon class="warning">warning</mat-icon>
            <p class=" text-[#8a6d3b] font-bold">
              La moins chère sera offerte
            </p>
          </div>
        }
        @for (line of getPromotionCompositionText(item).split('\n'); track trackCompositionLine(line, $index)) {
          <div class="m-0">
            @if (line.startsWith('📝 Produits Offerts')) {
              <div class="flex items-center justify-between mt-3">
                <div class="flex items-center gap-1">
                  <span class="font-bold text-green-700">{{ line.replace('📝 ', '') }}</span>
                  @if (getReductionType(item) === 'FIXED_AMOUNT') {
                    <div class="font-bold text-green-700">:({{ calculateFinalOfferedPrice(item) }}€)</div>
                  }
                  @if (getReductionType(item) === 'SET_PRICE') {
                    <div class="font-bold text-green-700">
                      ({{ getSetPriceValue(item) | number:'1.2-2' }}€)
                    </div>
                  }
                </div>
                @if (getReductionType(item) === 'FIXED_AMOUNT') {
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    {{ getFixedAmountValue(item) }}€
                  </span>
                }
              </div>
            }
            @if (line.startsWith('📝 Produits Achetés')) {
              <div class="flex items-center justify-between mt-3">
                <span class="font-bold text-blue-600">{{ line.replace('📝 ', '') }}</span>
              </div>
            }
            @if (line.startsWith('[PRODUCT]')) {
            <div class="font-semibold text-site">
              {{ line.replace('[PRODUCT]', '') }}
  </div>
}
            @if (line.includes(':') && line.includes('€') &&
              !line.startsWith('📝') && !line.startsWith('Sans') &&
              !line.startsWith('Suppléments') && !line.startsWith('Accompagnements')) {
              <div
                class="flex items-center gap-2 font-semibold">
                <span class="text-site">{{ line.split(':')[0] }}</span>
                @if (getReductionType(item) === 'PERCENTAGE' && isProductOffered(line, item)) {
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    -{{ getPercentageValue(item) }}%
                  </span>
                  <span class="line-through text-gray-400 text-sm">{{ getOriginalPrice(line) | number:'1.2-2' }}
                  €</span>
                  <span
                    class="text-green-600 font-bold">{{ calculateDiscountedPrice(line, item) | number:'1.2-2' }}
                  €</span>
                }
                @if (getReductionType(item) === 'FIXED_AMOUNT' && isProductOffered(line, item)) {
                  <span class="text-gray-800">{{ getPriceFromLine(line) | number:'1.2-2' }}€</span>
                }
                @if (!isProductOffered(line, item)) {
                  <span class="text-blue-600">{{ getPriceFromLine(line) | number:'1.2-2'}}€</span>
                }
              </div>
            }
            @if (line.startsWith('Sans :')) {
              <div class="text-red-600 pl-4">{{ line }}</div>
            }
            @if (line.startsWith('Accompagnements')) {
              <div class="text-content-base pl-4">{{ line }}</div>
            }
            <!--                    <span *ngIf="line.startsWith('Suppléments')" class="block pl-4 text-gray-700">{{ line }}</span>-->
            @if (line.startsWith('Suppléments')) {
              <div class="pl-4 text-content-base">
                <span>{{ line.split(':')[0] }} : </span>
                @for (part of line.split(':')[1].split('|||'); track trackCompositionLine(part, $index); let last = $last) {
                  @if (part.includes('[CAT]')) {
                    <span class="text-orange-500 font-semibold">
                      {{ part.split('-')[0].replace('[CAT]', '').trim() }}
                    </span>
                    - {{ part.split('-').slice(1).join('-') }}
                  } @else {
                    {{ part }}
                  }
                  @if (!last) {
                    <span>, </span>
                  }
                }
              </div>
            }
            @if (line.includes('Note: La promotion')) {
              <div
                class="text-xs text-yellow-600 bg-yellow-50 p-2 rounded mt-2">
                {{ line.replace('⚠️ ', '') }}
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
</div>
<!-- QUANTITY + PRICE -->
<div class="flex items-center pt-3 border-t border-gray-300"
  [class.justify-between]="!isOrderOffer(item)"
  [class.justify-end]="isOrderOffer(item)">
  @if (!isOrderOffer(item) && !isRedeemItem(item)) {
    <div class="flex items-center gap-2">
      <button
        (click)="decrementQuantity(item.id)"
              class=" cursor-pointer h-7 w-7 flex text-[#1a1a1a] items-center justify-center rounded-full bg-[#fafafa]
              hover:bg-border border border-gray-300 transition-colors hover:bg-gray-300">
        -
      </button>
      <span class="font-bold min-w-[30px] text-center">
        {{ item.quantity }}
      </span>
      <button
        (click)="incrementQuantity(item.id)"
              class="cursor-pointer h-7 w-7 text-[#1a1a1a] flex items-center justify-center rounded-full bg-[#fafafa]
               border border-gray-300 transition-colors hover:bg-gray-300">
        +
      </button>
    </div>
  }
  <span class="font-bold text-primary text-lg">
    {{ getItemDisplayTotal(item) | number:'1.2-2' }} €
  </span>
</div>
</div>
}
</div>
}
</div>
<!-- FOOTER FIXE -->
@if (!cartService.isEmpty()) {
  <div class="flex-shrink-0 card border-t-2 border-gray-200 p-4">
    @if (hasOrderDiscountPromoCode()) {
      <div
        class="flex items-center justify-between bg-green-50 border border-green-200 rounded-xl px-4 py-3 mb-3">
        <div class="flex items-center gap-2">
          <mat-icon class="text-green-600 text-[18px]" style="font-size:18px;">local_offer</mat-icon>
          <div>
            <p class="text-sm font-bold text-green-700">
              {{ getOrderDiscount().promotion?.promoCode }}
            </p>
            <p class="text-xs text-green-600">{{ orderDiscountBadge()}} sur votre commande</p>
          </div>
        </div>
        <button (click)="removeOrderDiscount()"
          class="text-gray-400 hover:text-red-500 transition cursor-pointer">
          <mat-icon style="font-size:18px; width:18px; height:18px; line-height:18px;">close</mat-icon>
        </button>
      </div>
    }
    <!-- Sous-total + Réduction + Total -->
    @if (hasOrderDiscountPromoCode()) {
      <div class="space-y-2 mb-4">
        <div class="flex justify-between items-center text-sm text-site">
          <span>Sous-total</span>
          <span class="font-semibold">{{ getSubTotal() | number:'1.2-2' }} €</span>
        </div>
        <div class="flex justify-between items-center text-sm text-green-600">
          <span>Réduction
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-800">
              {{ orderDiscountBadge() }}
            </span></span>
            <span class="font-bold">-{{ getDiscountAmount() | number:'1.2-2' }} €</span>
          </div>
          <div class="flex justify-between items-center text-xl font-bold border-t pt-2">
            <span class="text-site">Total</span>
            <!-- ✅ getFinalTotal() et non cartService.totalPrice() -->
            <span class="text-site">{{ getFinalTotal() | number:'1.2-2' }} €</span>
          </div>
        </div>
      } @else {
        <div class="flex justify-between items-center mb-4 text-xl font-bold">
          <span class="text-site">Total</span>
          <span class="text-site">
            {{ cartService.totalPrice() | number:'1.2-2' }} €
          </span>
        </div>
      }
      @if (!isMinimumOrderReached()) {
        <div
          class="bg-warning-soft border-l-4 border-warning-dim p-3 mb-4 rounded">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-warning-content fill-warning-content" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.37 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"/>
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm text-warning-content font-medium">
                  {{ getMinimumOrderWarning() }}
                </p>
              </div>
            </div>
          </div>
        }
        <div class="space-y-3">
          <!--      <button-->
          <!--        type="button"-->
      <!--        class="w-full py-3 rounded-lg font-bold cursor-pointer transition-all duration-200 flex items-center-->
      <!--        justify-center gap-2 bg-orange-500 text-white hover:bg-orange-600"-->
      <!--        (click)="openPromoCodeDialog()"-->
      <!--      >-->
      <!--        <span class="text-[14px] font-medium">Code Promo</span>-->
      <!--        <mat-icon class="text-[16px]">confirmation_number</mat-icon>-->
      <!--      </button>-->
      @if (!hasAnyPromoCodeApplied()) {
<div class="flex items-center gap-2">
        <input
          [(ngModel)]="promoCodeInput"
              (keyup.enter)="searchPromoCode()"
              placeholder="Code promo"
          class="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm
             focus:outline-none focus:border-primary"/>
             @if(!isMilano){

              <button
                [matButton]="themeConfig.appearance.button.neutral"
                (click)="searchPromoCode()"
                [disabled]="!promoCodeInput.trim()"
          class=" py-2">
                Appliquer
              </button>
          }
          @if(isMilano){
          <button
            (click)="searchPromoCode()"
            [disabled]="!promoCodeInput.trim()"
            class="px-4 py-2 bg-primary text-white rounded-lg text-sm font-semibold
             hover:bg-primary/60 disabled:bg-gray-300 disabled:cursor-not-allowed
             transition-all whitespace-nowrap">
            Appliquer
          </button>

          }
            </div>
          }
          @if (!isMilano){

          <button
            [disabled]="!isMinimumOrderReached()"
            (click)="openDialogCommand()"
            class="w-full py-2 rounded-field font-bold cursor-pointer transition-all duration-200 flex items-center justify-center"
            [ngClass]="{
            'bg-accent text-accent-content hover:bg-accent/50': isMinimumOrderReached(),
            'bg-gray-300 text-gray-500 cursor-not-allowed': !isMinimumOrderReached()
            }">

            @if (!isMinimumOrderReached()) {
            <span>Ajouter des articles</span>
            } @else {
            <span>Commander</span>
            }
          </button>
          <button
            [matButton]="themeConfig.appearance.button.danger"
            (click)="clearCart()"
            class="w-full py-3 font-bold btn-danger">
            Vider le panier
          </button>
          }
          @if (isMilano){
          <button
      [disabled]="!isMinimumOrderReached()"
      (click)="openDialogCommand()"
      class="w-full py-3 rounded-lg font-bold cursor-pointer transition-all duration-200 flex items-center justify-center"
      [ngClass]="{
          'bg-primary text-white hover:bg-primary/60': isMinimumOrderReached(),
          'bg-gray-300 text-gray-500 cursor-not-allowed': !isMinimumOrderReached()
          }">
        @if (!isMinimumOrderReached()) {
          <span>Ajouter des articles</span>
          } @else {
          <span>Commander</span>
          }
      </button>
            <button
        (click)="clearCart()"
        class="w-full bg-white text-red-500 border-2 border-red-500 py-3
               rounded-lg font-semibold hover:bg-red-50 transition cursor-pointer">
        Vider le panier
      </button>



          }
        </div>
      </div>
    }
  </div>
}

@if (isMenuOpen || isMenuClosing) {
  <div
    class="lg:hidden fixed inset-0 bg-[#242424] bg-opacity-70 z-[99999]"
    [class.bg-opacity-0]="isMenuClosing"
    (click)="closeMenu()">
    <div
      class="absolute top-0 left-0 right-0 z-[99999]"
      [class.menu-slide-animation]="isMenuOpen && !isMenuClosing"
      [class.menu-slide-out-animation]="isMenuClosing"
      (click)="$event.stopPropagation()">
      <!-- Header with Logo and Close Button -->
      <div class="flex items-center justify-between p-4 ">
<a [routerLink]="['']" class="relative w-12 h-12 flex items-center justify-center overflow-hidden">
  <img
    [ngSrc]="logo() || 'assets/images/placeholders/placeholder.webp'"
    [alt]="'Logo pour ' + (restoName() || 'le restaurant')"
    fill
    priority
    class="object-contain object-center p-1 cursor-pointer transition-transform hover:scale-110" />
</a>
          <div
            (click)="closeMenu()"
            class="flex justify-center items-center bg-secondary/20 border border-secondary/40 w-10 h-10 rounded-full">
            <mat-icon class="material-symbols-outlined icon-secondary">close</mat-icon>
          </div>
        </div>
        <!-- Menu Items -->
        <div class="p-6 space-y-6 flex flex-col max-h-[480px] overflow-y-auto">
          <!-- Commander -->
          <span class="font-bold uppercase text-[#FFFFFF] text-lg tracking-wide text-center"
          (click)="openDialog(); closeMenu()">Commander</span>
          <a class="font-bold uppercase text-[#FFFFFF] text-lg tracking-wide text-center" (click)="closeMenu()"
          [routerLink]="['/restaurant']">Notre Restaurant</a>
          <a class="font-bold uppercase text-[#FFFFFF] text-lg tracking-wide text-center" (click)="closeMenu()"
          [routerLink]="['/allergene']">Allergènes</a>
          <a class="font-bold uppercase text-[#FFFFFF] text-lg tracking-wide text-center" (click)="closeMenu()"
          [routerLink]="['/cgv']">C.G.V</a>
          <a class="font-bold uppercase text-[#FFFFFF] text-lg tracking-wide text-center" (click)="closeMenu()"
          [routerLink]="['/mentions-legal']">Mentions Légales</a>
          <!-- Call to Action Section -->
          <div class="pt-4 border-t border-secondary text-center">
            <p class="text-[#FFFFFF] font-bold text-base mb-6">
              UN CLIC: COMMANDEZ<br>DÈS MAINTENANT !
            </p>
            <!-- Phone Numbers -->
            <div class="space-y-3">
              @for (phone of phones(); track phone) {
                <div>
                  <a [href]="'tel:' + phone"
                    class="flex items-center justify-center gap-3 icon-secondary hover:text-secondary transition-colors">
                    <div
                      class="flex justify-center items-center bg-secondary/20 border border-secondary/40 w-10 h-10 rounded-full">
                      <mat-icon class="material-symbols-outlined icon-secondary">call</mat-icon>
                    </div>
                    <span class="font-bold text-lg">{{phone}}</span>
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
